var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38453_29826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 11C9.42811 11 11.6667 8.76142 11.6667 6C11.6667 3.23858 9.42811 1 6.66669 1C3.90526 1 1.66669 3.23858 1.66669 6C1.66669 8.76142 3.90526 11 6.66669 11Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 8.5H6.67169",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21167 4.50028C5.32922 4.16612 5.56125 3.88434 5.86665 3.70485C6.17205 3.52536 6.53112 3.45975 6.88026 3.51964C7.2294 3.57953 7.54608 3.76105 7.77421 4.03205C8.00234 4.30305 8.1272 4.64605 8.12667 5.00028C8.12667 6.00028 6.62667 6.50028 6.62667 6.50028",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38453_29826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.666687)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.e628eda19e564ed0635e03cf1e51d845.svg";
export { ForwardRef as ReactComponent };